import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const tasksApi = createApi({
  reducerPath: 'tasksApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token'); // 👈 fetch token from localStorage
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Tasks', 'CustomFilters'],
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getAllTasks: builder.query({
      query: ({ workspaceId, query }) => {
        return {
          url: `/tasks/${workspaceId}/myTasks${query}`,
          method: 'GET',
        };
      },
      providesTags: (result, error, { workspaceId }) => [
        { type: 'Tasks', id: workspaceId },
        'Tasks',
      ],
    }),
    getCustomFilters: builder.query({
      query: ({ workspaceId }) => ({
        url: `filter/${workspaceId}/user`,
        method: 'GET',
      }),
      providesTags: (result, error, { workspaceId }) => [
        { type: 'CustomFilters', id: workspaceId },
      ],
    }),
    exportProjectTasks: builder.query({
      // Accepts projectId + optional query string for fields
      query: ({ projectId, query = '' }) => ({
        url: `/tasks/project/${projectId}/export${query}`,
        method: 'GET',
        // override to expect blob (CSV)
        responseHandler: async (response) => {
          // returns blob for download
          return await response.blob();
        },
      }),
    }),
    exportWorkspaceTasks: builder.query({
      // Accepts projectId + optional query string for fields
      query: ({ workspaceId, query = '' }) => ({
        url: `/tasks/workspace/${workspaceId}/export${query}`,
        method: 'GET',
        // override to expect blob (CSV)
        responseHandler: async (response) => {
          // returns blob for download
          return await response.blob();
        },
      }),
    }),
    updateTask: builder.mutation({
      query: (body) => ({
        url: `/tasks/update`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Tasks'],
    }),
  }),
});

export const {
  useGetAllTasksQuery,
  useLazyGetAllTasksQuery,
  useGetCustomFiltersQuery,
  useExportProjectTasksQuery,
  useLazyExportProjectTasksQuery,
  useExportWorkspaceTasksQuery,
  useLazyExportWorkspaceTasksQuery,
  useUpdateTaskMutation,
} = tasksApi;
